import { render } from "./clientType.vue?vue&type=template&id=38386bd0&scoped=true"
import script from "./clientType.vue?vue&type=script&lang=js"
export * from "./clientType.vue?vue&type=script&lang=js"

import "./clientType.vue?vue&type=style&index=0&id=38386bd0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38386bd0"]])

export default __exports__